// src/components/auth/UserProfile.jsx
import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { User, LogOut, LogIn, Loader2, ChevronDown, Store, LayoutDashboard } from 'lucide-react'; // [BARU] Import LayoutDashboard
import './UserProfile.css';

const UserProfile = ({ user, isAuthenticated, authLoading, onLogout }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  
  // Referensi untuk mendeteksi klik di luar menu
  const dropdownRef = useRef(null);

  const ssoLoginUrl = import.meta.env.VITE_LKPP_SSO_URL || '#';
  const adminPanelUrl = import.meta.env.VITE_ADMIN_PANEL_URL?.replace(/\/$/, '') || '#';

  // Fungsi Potong Nama
  const truncateName = (name, maxLength = 12) => {
    if (!name) return 'User';
    return name.length > maxLength ? name.substring(0, maxLength) + '...' : name;
  };

  // Tutup dropdown jika user klik di luar area menu
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  if (authLoading) {
    return (
      <div className="user-profile loading">
        <Loader2 className="animate-spin" />
        <span className="user-name">Memuat...</span>
      </div>
    );
  }

  // =========================================================
  // --- TAMPILAN SUDAH LOGIN ---
  // =========================================================
  if (isAuthenticated && user) {
    return (
      <div 
        className="user-profile authenticated"
        ref={dropdownRef}
        onClick={() => setIsDropdownOpen(!isDropdownOpen)} // UBAH JADI KLIK
      >
        <div className="avatar">
          {user.realName ? user.realName.charAt(0).toUpperCase() : 'U'}
        </div>
        
        <div className="user-info">
          <span className="user-name" title={user.realName || user.username}>
            {truncateName(user.realName || user.username)}
          </span>
          <span className="user-role">{user?.role || 'Pengguna'}</span>
        </div>
        
        <ChevronDown size={16} />

        {isDropdownOpen && (
          <div className="profile-dropdown">
            <Link to="/profile" className="dropdown-item">
              <User size={16} />
              <span>Profil Saya</span>
            </Link>
            
            {/* ========================================================= */}
            {/* [BARU] TOMBOL MENUJU DASHBOARD ADMIN PANEL (VIA SSO BRIDGE) */}
            {/* ========================================================= */}
            <a 
              href={`${adminPanelUrl}/panel/sso-bridge?token=${localStorage.getItem('dietalase_session_token')}`}
              className="dropdown-item"
            >
              <LayoutDashboard size={16} />
              <span>Panel Dietalase</span>
            </a>

            <button onClick={onLogout} className="dropdown-item">
              <LogOut size={16} />
              <span>Keluar/Logout</span>
            </button>
          </div>
        )}
      </div>
    );
  }

  // =========================================================
  // --- TAMPILAN TAMU (BELUM LOGIN) ---
  // =========================================================
  return (
    <div 
      className="user-profile authenticated"
      ref={dropdownRef}
      onClick={() => setIsDropdownOpen(!isDropdownOpen)} // UBAH JADI KLIK
    >
      <div className="avatar guest">
        <User size={20} />
      </div>
      <div className="user-info">
        <span className="user-name">Tamu</span>
        <span className="user-role">Belum Login</span>
      </div>
      <ChevronDown size={16} />

      {isDropdownOpen && (
        <div className="profile-dropdown">
          <a href={ssoLoginUrl} className="dropdown-item">
            <LogIn size={16} />
            <span>Login</span>
          </a>
          <a
            href={`${adminPanelUrl}/panel/login`}
            target="_blank"
            rel="noopener noreferrer"
            className="dropdown-item"
          >
            <Store size={16} />
            <span>Jual di Dietalase</span>
          </a>
        </div>
      )}
    </div>
  );
};

export default UserProfile;